module.exports = __webpack_public_path__ + "img/gray-men(1).b68613e7.svg";